<template>
    <div class="d-flex flex-column justify-content-center align-items-center p-5 m-5">
        <h1>404</h1>
        <h2>page not found</h2>
    </div>
</template>

<script>
    export default {
        name: "Error404"
    }
</script>

<style scoped lang="scss">
    @import "../../sass/base";
    h1 {
       font-size: 20rem;
    }
    h2  {
        font-size: 5rem;
    }
    h1,h2 {
        color: $gray-400;
        text-shadow: 2px 2px 2px $gray-600;
    }
</style>
